import childs from "../../asserts/images/childs.svg";
import "./banner.scss";
import { useNavigate } from "react-router-dom";

const Banner = () => {
  const navigate = useNavigate();
  const donatepage = () => {
    navigate("/donatenow");
  };
  return (
    <div className="d-flex banner px-0">
      <div className="sub-banner">
        <div>
          <h5 className="welcome">Welcome to Pagirndhunn</h5>
          <h1 className="bring-smiles">
            Bring smiles by sharing the goodness of your life.
          </h1>
        </div>
        <div className="button-section">
          <button className="donate" onClick={donatepage}>Donate Now</button>
          <button className="becomebutton">Become A Volunteer</button>
        </div>

        <div className="text-card">
          <div className="benefits-box">
            <div className="badge">80G</div>
            <div className="content">
              <div className="title">Enjoy Tax Benefits </div>
              <div className="subtitle">
                Receive an 80G certificate for your contribution.
              </div>
            </div>
          </div>
          <div className="empty">empty1</div>
          <div className="empty2">empty2</div>
        </div>
      </div>
      <img src={childs} alt="" className="child-image" />
    </div>
  );
};
export default Banner;
